// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"62174f5c","412":"bba4b0af","453":"f607884c","514":"a96c4a4a","516":"9944b97c","521":"0497519d","616":"3f72ceeb","937":"1a0ae910","940":"7620cd5f","964":"4c98b593"}[chunkId] + ".chunk.js";
};